import { ApplicationFeature } from "@green0meter/api-client";
import React, { FC } from "react";
import { CircularProgress } from "@mui/material";

import { useGetCurrentCompanyInfo } from "@api";
import { useUserStore } from "@store/user";
import { NotAuthorized } from "@components/common";

type RequireFeature = {
  children: React.ReactNode;
  features: ApplicationFeature[];
};

const RequireFeature: FC<RequireFeature> = ({ children, features }) => {
  const { user } = useUserStore();
  const { currentCompanyInfo, isPendingCurrentCompanyInfo } =
    useGetCurrentCompanyInfo(user);

  const hasAccess = features.some((f) =>
    currentCompanyInfo?.companyFeatureFunctionalities.some(
      (uf) => uf.applicationFeature === f,
    ),
  );

  if (isPendingCurrentCompanyInfo) {
    return <CircularProgress />;
  }

  if (!hasAccess) {
    return <NotAuthorized />;
  }

  return <>{children}</>;
};

export default RequireFeature;
